import { RestrictedPage } from 'routes/CrudRoute';

import { ProductList } from './ProductList';
import { ProductCreate } from './ProductCreate';
import { ProductEdit } from './ProductEdit';

import { MachineLendingList } from './MachineLendingList';
import { MachineLendingExtend } from './MachineLendingEdit';

import { ProductOrderList } from './ProductOrderList';

import { PromotionList } from './PromotionList';
import { PromotionCreate } from './PromotionCreate';
import { PromotionEdit } from './PromotionEdit';

import { AppSubscriptionList } from './AppSubscriptionList';
import { AppSubscriptionExtend } from './AppSubscriptionExtend';
import { AppSubscriptionAdjust } from './AppSubscriptionAdjust';
import { AppSubscriptionUpdate } from './AppSubscriptionUpdate';

import * as urls from './urls';
import * as utils from './utils';


export const ProductResources = [
  {
    "name": utils.ProductResourceName,
    "frontendPath": urls.productFrontendPath,
    "backendPath": urls.productBackendPath,
    "list": ProductList,
    "create": ProductCreate,
    "edit": ProductEdit,
    "showInSideMenu": true,
  },
  {
    "name": utils.MachineLendingResourceName,
    "frontendPath": urls.machineLendingFrontendPath,
    "backendPath": urls.machineLendingBackendPath,
    "list": MachineLendingList,
    "showInSideMenu": true,
  },
  {
    "name": utils.ProductOrderResourceName,
    "frontendPath": urls.productOrderFrontendPath,
    "backendPath": urls.productOrderBackendPath,
    "list": ProductOrderList,
    "showInSideMenu": true,
  },
  {
    "name": utils.PromotionResourceName,
    "frontendPath": urls.promotionFrontendPath,
    "backendPath": urls.promotionBackendPath,
    "list": PromotionList,
    "create": PromotionCreate,
    "edit": PromotionEdit,
    "showInSideMenu": true,
  },
  {
    "name": utils.PromotionBenefitResourceName,
    "showInSideMenu": false,
  },
  {
    "name": utils.PaymentTypeResourceName,
    "showInSideMenu": false,
  },
  {
    "name": utils.PromotionTriggerResourceName,
    "showInSideMenu": false,
  },
  {
    "name": utils.AppSubscriptionResourceName,
    "frontendPath": urls.appSubscriptionFrontendPath,
    "backendPath": urls.appSubscriptionBackendPath,
    "list": AppSubscriptionList,
    "showInSideMenu": true,
  },
];

export const ProductCustomRoutes = [
  {
    "name": "Machine Lending Extend",
    "frontendPath": urls.machineLendingExtendFrontendPath,
    "showInSideMenu": false,
    "render": RestrictedPage(MachineLendingExtend, 'machine lending extend', {
      'resource': utils.MachineLendingResourceName,
      'updateDataOnMount': false,
      'redirectPath': urls.machineLendingFrontendPath,
      'title': 'Machine Lending Extend',
    })
  },{
    "name": "App Subscription Extension",
    "frontendPath": urls.appSubscriptionExtendFrontendPath,
    "showInSideMenu": false,
    "render": RestrictedPage(AppSubscriptionExtend, 'app subscription extend', {
      'resource': utils.AppSubscriptionResourceName,
      'updateDataOnMount': false,
      'redirectPath': urls.appSubscriptionFrontendPath,
      'title': 'App Subscription Extension',
    })
  },{
    "name": "App Subscription Change Status",
    "frontendPath": urls.appSubscriptionUpdateFrontendPath,
    "showInSideMenu": false,
    "render": RestrictedPage(AppSubscriptionUpdate, 'app subscription change status', {
      'resource': utils.AppSubscriptionResourceName,
      'updateDataOnMount': false,
      'redirectPath': urls.appSubscriptionFrontendPath,
      'title': 'App Subscription Change Status',
    })
  },{
    "name": "App Subscription Expiry Date Adjustment",
    "frontendPath": urls.appSubscriptionAdjustFrontendPath,
    "showInSideMenu": false,
    "render": RestrictedPage(AppSubscriptionAdjust, 'app subscription expiry date adjustment', {
      'resource': utils.AppSubscriptionResourceName,
      'updateDataOnMount': false,
      'redirectPath': urls.appSubscriptionFrontendPath,
      'title': 'App Subscription Expiry Date Adjustment',
    })
  }
];



// WEBPACK FOOTER //
// ./src/routes/product/resources.js